module.exports = __webpack_public_path__ + "img/autralis_white.e4038c54.png";